import React from 'react';
import { MapPin, Calendar } from 'lucide-react';
import { experience } from '../data/mock';

const Experience = () => {
  return (
    <section
      id="experience"
      className="py-20 md:py-24 px-6 border-b border-stone-400/25 dark:border-stone-500/20"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="text-4xl font-bold text-stone-900 dark:text-stone-100 mb-4 leading-tight">
            Experience
          </h2>
          <div className="w-16 h-1 bg-amber-800 dark:bg-amber-600 rounded-full mb-4"></div>
          <p className="text-base text-stone-600 dark:text-stone-400 max-w-2xl">
            Building quality software across development and testing roles
          </p>
        </div>

        <div className="space-y-6">
          {experience.map((exp, index) => (
            <div
              key={exp.id}
              className="p-6 rounded-2xl bg-white/60 dark:bg-stone-800/60 backdrop-blur-md border border-stone-200/50 dark:border-stone-700/50 hover:shadow-xl transition-all"
            >
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-3 py-1 bg-amber-100 dark:bg-amber-900/30 text-amber-900 dark:text-amber-200 rounded-full text-xs font-medium uppercase tracking-wider">
                      {exp.duration}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-stone-900 dark:text-stone-100 mb-1">
                    {exp.role}
                  </h3>
                  <p className="text-base text-amber-800 dark:text-amber-600 font-medium mb-2">{exp.company}</p>
                  <div className="flex items-center space-x-1 text-stone-600 dark:text-stone-400">
                    <MapPin className="w-3.5 h-3.5" />
                    <span className="text-xs">{exp.location}</span>
                  </div>
                </div>
              </div>

              <ul className="space-y-2 mb-4">
                {exp.responsibilities.map((responsibility, idx) => (
                  <li
                    key={idx}
                    className="flex items-start space-x-2 text-sm text-stone-600 dark:text-stone-300"
                  >
                    <span className="w-1 h-1 bg-amber-800 dark:bg-amber-600 rounded-full mt-1.5 flex-shrink-0"></span>
                    <span>{responsibility}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-wrap gap-2">
                {exp.techStack.map((tech, idx) => (
                  <span
                    key={idx}
                    className="px-2.5 py-1 bg-stone-100 dark:bg-stone-700 text-stone-700 dark:text-stone-300 rounded-full text-xs font-medium"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
